import React, { Component } from 'react';

import { Card } from "react-bootstrap";

export class OrganisationList extends Component {
    render() {
        return (
            this.props.organisations.map(organisation => (
                <a href={"/" + organisation.orgName}>
                    <Card className="org-card d-f mb-1">
                        <Card.Body className="d-f i-c">
                            <span className="custom_icon">{organisation.orgName.substring(0, 1)}</span>
                            &nbsp;&nbsp;
                            <span className="f-14">{organisation.orgName}</span>
                        </Card.Body>
                    </Card>
                </a>
            ))
        );
    }
}
